import { Button, Card, Form, Layout } from 'antd';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderPrincipal from '../../components/HeaderPrincipal';
import InputNormal from '../../components/InputNormal';
import { useAuth } from '../../contexts/AuthContext';
import { userAccount } from '../../types/UserAccount';


export default function LoginView() {
    const navigate = useNavigate();
    const [loadingLogin, setLoadingLogin] = useState(false);
    const { handleLogin } = useAuth();

    const onFinish = async (values: userAccount) => {
        setLoadingLogin(true);
        handleLogin(values).then((resp: any) => {
            setLoadingLogin(false);
        });

    };

    return (
        <>
            <HeaderPrincipal showLogoutButton={false} />
            <div className='tela-login'>
                <Layout>
                    <div className="imagem">
                    </div>
                    <Card className='login-section-form'>
                        <div className="login-div" style={{ height: '100px', marginBottom: '20px', textAlign: 'center' }}>
                            <img src='/fslogo.png' width={80} height={100} alt="Logo Marca da aplicação FSJus"></img>
                        </div>
                        <Form onFinish={onFinish} layout='vertical' className='login-form'>
                            <div style={{ fontSize: 12, fontWeight: 'bold', textAlign: 'center' }}>
                                FSJUS - Sistema de Gestão Jurídica
                            </div>
                            <br />
                            <InputNormal
                                label="Email"
                                name="user"
                                id='vetta-input-username'
                                className="login-user-name"
                                required
                            />
                            <InputNormal
                                label="Senha"
                                name="password"
                                id='vetta-input-password'
                                className="login-user-password"
                                required
                                type="password"
                            />
                            <div className="btns-login">
                                <Button type="primary" htmlType="submit" loading={loadingLogin}>
                                    Entrar
                                </Button>
                            </div>
                        </Form>
                    </Card>
                </Layout>
            </div>
        </>
    )
}
